module.exports = __webpack_public_path__ + "static/media/boom-stage-speakers.aa256a0e.jpg";